import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import { t } from '../../../modules/infra/i18n';
import {
  userUpdateShop,
  fetchShopWithSubscription,
} from './actions';
import { fetchShopLdFlags } from '../../admin/shops/actions';
import ShopForm from './shopForm';
import {
  getinitialValuesFromShop,
  getInitialEmptyValues,
  omitAutoPayoutSettings,
} from '../../common/helpers/shops';
import withNotifications from '../../common/withNotifications';
import {
  canUserModifyShopDetails,
} from '../../common/helpers/users';
import withLoading from '../../common/withLoading';
import { flagNames, withInjectFeatureFlagsToProps } from '../../../modules/infra/feature-flags';

const WrappedForm = withLoading(ShopForm);

class EditShop extends Component {

  constructor(props) {
    super(props);

    this.state = {
      initialValues: getInitialEmptyValues({
        useDefaultAutoPayoutFeeValues: props[flagNames.AUTOPAYOUT_SELF_SERVE],
      }),
      loading: true,
      shopLdFlags: {},
    };
    this.saveUpdatedShopBind = (...args) => this.saveUpdatedShop(...args);
  }

  saveUpdatedShop(model) {
    let update = model;
    if (this.props[flagNames.AUTOPAYOUT_SELF_SERVE]) {
      update = omitAutoPayoutSettings(model);
    }

    return this.props.modifyShop(this.props.shop, update, this.state.initialValues)
      .then(() => {
        this.props.addNotification({
          title: t('settings:edit_shop.success_title'),
          level: 'success',
          message: t('settings:edit_shop.success_message'),
        });
        this.props.router.push('/');
      });
  }

  componentDidMount() {
    if (this.props.shop) {
      this.props.fetchShopLdFlags(this.props.shop)
        .then(flags => this.setState({ shopLdFlags: flags }))
        .catch(() => this.setState({ shopLdFlags: {} }));
    }

    this.props.getShop(this.props.shop)
      .then(shop => getinitialValuesFromShop(shop, this.props.timezone))
      .then(shop => this.setState({
        initialValues: shop,
        loading: false,
      }))
      .catch(() => this.setState({ loading: false }));
  }

  render() {
    return (
      <div>
        <WrappedForm
          showLoading={this.state.loading}
          saveUpdatedShop={this.saveUpdatedShopBind}
          initialValues={this.state.initialValues}
          cancelHref="/"
          disabled={!canUserModifyShopDetails(this.props.permissions)}
          shopLdFlags={this.state.shopLdFlags}
        />
      </div>
    );
  }
}

EditShop.propTypes = {
  shop: PropTypes.string,
  timezone: PropTypes.string,
  modifyShop: PropTypes.func.isRequired,
  getShop: PropTypes.func.isRequired,
  fetchShopLdFlags: PropTypes.func.isRequired,
  addNotification: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired,
  autopayoutSelfServe: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  shop: state.auth.shop,
  timezone: state.auth.timezone,
  permissions: state.auth.permissions,
});

const mapDispatchToProps = {
  modifyShop: userUpdateShop,
  getShop: fetchShopWithSubscription,
  fetchShopLdFlags,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withNotifications,
  withRouter,
  // TODO remove when flagNames.AUTOPAYOUT_SELF_SERVE is removed
  withInjectFeatureFlagsToProps([flagNames.AUTOPAYOUT_SELF_SERVE]),
)(EditShop);
